module.exports = __webpack_public_path__ + "static/media/image 90.2acced84.png";